import React, { useContext } from 'react';
import AppRoutes from './routes';
import TransactionLoader from './utils/TransactionLoader';
import GlobalLoader from './components/GlobalLoader';
import { GlobalContext } from './Context/GlobalState';

function App() {
  const { transactionLoader } = useContext(GlobalContext);

  return (
    <TransactionLoader text="Please Wait..." isActive={transactionLoader}>
      <GlobalLoader />
      <AppRoutes />
    </TransactionLoader>
  );
}

export default App;
